/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var CardBox, CardGroup, PureRenderMixin, React, ReactDOM, Score, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

CardBox = require('./card-box');

CardGroup = require('./card-group');

Score = require('./score');

css = require('../css/game.styl');

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  displayName: 'Game',
  isUserCzar: function() {
    var ref;
    return ((ref = this.props.game.players[this.props.game.czarIndex]) != null ? ref.id : void 0) === this.props.user.data.id;
  },
  pickCard: function(cardId) {
    if (this.isUserCzar()) {
      return;
    }
    if (this.props.cards.items[cardId]) {
      this.props.actions.pickCard(this.props.game.id, cardId);
    }
  },
  pickWinner: function(userId) {
    if (!this.isUserCzar()) {
      return;
    }
    this.props.actions.pickWinner(this.props.game.id, userId);
  },
  getTotalWhiteCardsNeeded: function() {
    var pickingPlayers;
    pickingPlayers = this.props.game.players.filter((function(_this) {
      return function(player, index) {
        var ref;
        if (((ref = _this.props.game.players[_this.props.game.czarIndex]) != null ? ref.id : void 0) === player.id) {
          return false;
        }
        if (player.state !== 'online') {
          return false;
        }
        return true;
      };
    })(this));
    return this.props.game.cardsRequired * pickingPlayers.length;
  },
  render: function() {

    /*
    			BLACK CARD
     */
    var alreadyPicked, alreadyPickedReducer, amountPickedByMe, blackCard, card, cardsToPick, me, pickedCards, ref, whiteCards;
    if (card = this.props.cards.items[this.props.game.blackCard]) {
      blackCard = React.createElement(CardBox, {
        "key": card.id,
        "type": card.type,
        "customClassNames": [css['card'], css['black-card']]
      }, card.value);
    }

    /*
    			MINE PLAYER
     */
    me = null;
    this.props.game.players.some((function(_this) {
      return function(player) {
        if (player.id === _this.props.user.data.id) {
          return me = player;
        }
      };
    })(this));
    if (me && me.cards) {
      whiteCards = me.cards.map((function(_this) {
        return function(cardId) {
          card = _this.props.cards.items[cardId];
          return React.createElement(CardBox, {
            "key": card.id,
            "id": card.id,
            "didClick": _this.pickCard,
            "type": card.type,
            "customClassNames": [css['card']]
          }, card.value);
        };
      })(this));
    }

    /*
    			PICKED CARD GROUPS or STATE
     */
    pickedCards = [];
    cardsToPick = this.getTotalWhiteCardsNeeded();
    alreadyPickedReducer = (function(_this) {
      return function(count, playerId) {
        var amountPickedByPlayer, ref;
        amountPickedByPlayer = ((ref = _this.props.game.pickedCards[playerId]) != null ? ref.length : void 0) || 0;
        return count + amountPickedByPlayer;
      };
    })(this);
    alreadyPicked = Object.keys(this.props.game.pickedCards).reduce(alreadyPickedReducer, 0);
    amountPickedByMe = ((ref = this.props.game.pickedCards[me.id]) != null ? ref.length : void 0) || 0;
    if (this.isUserCzar() && alreadyPicked < cardsToPick) {
      pickedCards = React.createElement("div", {
        "className": css['payers-picking-cards']
      }, "JSI CZAR");
    } else if (!this.isUserCzar() && amountPickedByMe < this.props.game.cardsRequired) {
      pickedCards = React.createElement("div", {
        "className": css['payers-picking-cards']
      }, "VYBERTE KARTU");
    } else if (alreadyPicked < cardsToPick) {
      pickedCards = React.createElement("div", {
        "className": css['payers-picking-cards']
      }, "HRÁČI VYBÍRAJÍ KARTY");
    } else {
      this.props.game.randomPlayerOrder.forEach((function(_this) {
        return function(playerId) {
          var playerPickedCardIds, playerPickedCards;
          if (!(playerPickedCards = _this.props.game.pickedCards[playerId])) {
            return;
          }
          playerPickedCardIds = playerPickedCards.map(function(pickedCard) {
            return pickedCard.cardId;
          });
          return pickedCards.push(React.createElement(CardGroup, {
            "cards": _this.props.cards,
            "customClassNames": [css['grouped-cards']],
            "didClick": _this.pickWinner,
            "key": playerId,
            "pickedCards": playerPickedCardIds,
            "pickId": playerId
          }));
        };
      })(this));
    }
    return React.createElement("div", {
      "className": css['game']
    }, React.createElement("h2", {
      "className": css['heading']
    }, "Hra : ", this.props.game.name), React.createElement("div", {
      "className": css['picked-cards']
    }, blackCard, pickedCards), React.createElement("h2", null, "Karty v ruce"), React.createElement("div", {
      "className": css['player-cards']
    }, whiteCards), React.createElement(Score, {
      "game": this.props.game,
      "user": this.props.user
    }));
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "game.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/game.cjsx
 ** module id = 264
 ** module chunks = 0
 **/